<script>
import CommonWhatsappCampaignUtils from './CommonWhatsappCampaign.utils';

export default {
  data() {
    return {
      intervalBetweenMessages:
        CommonWhatsappCampaignUtils.defaultIntervalOption,
    };
  },
  computed: {
    smartOptions() {
      return CommonWhatsappCampaignUtils.intervalOptions;
    },
  },
  mounted() {
    this.$emit('selectedInterval', this.intervalBetweenMessages);
  },
  methods: {
    changeOption() {
      this.$emit('selectedInterval', this.intervalBetweenMessages);
    },
  },
};
</script>

<template>
  <div>
    <div>{{ $t('CAMPAIGN.ADD.FORM.MESSAGE.INTERVALS.DEFINED') }}</div>
    <p class="mt-0 mb-2">
      {{ $t('CAMPAIGN.ADD.FORM.MESSAGE.INTERVALS.DESCRIPTION') }}
    </p>
    <div>
      <div
        v-for="smartOption in smartOptions"
        :key="'smart_option'.concat(smartOption.time)"
      >
        <input
          :id="'smart_option'.concat(smartOption.time)"
          v-model="intervalBetweenMessages"
          class="inline"
          type="radio"
          :value="smartOption.value"
          @change="changeOption"
        />
        <label :for="'smart_option'.concat(smartOption.time)" class="inline">
          {{ $t(`CAMPAIGN.ADD.FORM.MESSAGE.INTERVALS.${smartOption.label}`) }}
          <span class="brightness-75">{{ smartOption.time }}</span>
        </label>
      </div>
    </div>
  </div>
</template>
